import { ContestTier } from '../types';

export const getContestTierName = (tier: ContestTier | undefined): string | undefined => {
    switch (tier) {
        case ContestTier.Bronze:
            return __('Bronze');
        case ContestTier.Silver:
            return __('Silver');
        case ContestTier.Gold:
            return __('Gold');
        case ContestTier.Platinum:
            return __('Platinum');
        default:
            return undefined;
    }
};
